import { RouteLocationNormalizedLoaded, RouteRecordRaw } from 'vue-router';
import Layout from '@/components/layout/index.vue';
import Welcome from '@/pages/welcome/index.vue';
import Login from '@/pages/login/index.vue';
import { useLayoutStore } from '@/store';

function getProps(route: RouteLocationNormalizedLoaded) {
  return route.query;
}

// 系统生成路由
export const routers: Array<RouteRecordRaw> = [
  {
    path: '/login',
    component: Login,
    name: 'login',
    meta: {
      title: '登录',
    },
  },
  {
    path: '/worker',
    component: Layout,
    name: 'main',
    props: getProps,
    redirect: '/worker/welcome',
    meta: {
      title: '主页',
      showOnly: true,
    },
    children: [
      {
        path: '/worker/welcome',
        component: Welcome,
        name: 'welcome',
        meta: { title: '欢迎', keepalive: false },
      },
      {
        path: '/worker/formSysMenu',
        component: () =>
          useLayoutStore().supportColumn
            ? import('@/pages/upms/formSysMenu/formSysColumnMenu.vue')
            : import('@/pages/upms/formSysMenu/index.vue'),
        name: 'formSysMenu',
        meta: { title: '菜单列表', keepalive: true },
      },
      {
        path: '/worker/formSysUser',
        component: () => import('@/pages/upms/formSysUser/index.vue'),
        name: 'formSysUser',
        meta: { title: '用户列表', keepalive: true },
      },
      {
        path: '/worker/formSysDept',
        component: () => import('@/pages/upms/formSysDept/index.vue'),
        name: 'formSysDept',
        meta: { title: '部门列表', keepalive: true },
      },
      {
        path: '/worker/formSysRole',
        component: () => import('@/pages/upms/formSysRole/index.vue'),
        name: 'formSysRole',
        meta: { title: '角色管理', keepalive: true },
      },
      {
        path: '/worker/formSysLoginUser',
        component: () => import('@/pages/upms/formSysLoginUser/index.vue'),
        name: 'formSysLoginUser',
        meta: { title: '在线用户', keepalive: true },
      },
      // 岗位模块路由配置
      {
        path: '/worker/formSysPost',
        component: () => import('@/pages/upms/formSysPost/index.vue'),
        name: 'formSysPost',
        meta: { title: '岗位管理', keepalive: true },
      },
      {
        path: '/worker/formSysDeptPost',
        component: () => import('@/pages/upms/formSysDeptPost/index.vue'),
        name: 'formSysDeptPost',
        props: getProps,
        meta: { title: '设置部门岗位', keepalive: true },
      },
      {
        path: '/worker/formSysDict',
        component: () => import('@/pages/upms/formSysDict/index.vue'),
        name: 'formSysDict',
        meta: { title: '字典管理', keepalive: true },
      },
      {
        path: '/worker/formSysOperationLog',
        component: () => import('@/pages/upms/formSysOperationLog/index.vue'),
        name: 'formSysOperationLog',
        meta: { title: '操作日志', keepalive: true },
      },
      // 404
      {
        path: '/:pathMatch(.*)*',
        component: () => import('@/pages/error/404.vue'),
        name: 'NotFound',
        meta: {
          title: '404',
        },
      },
      // 在线表单
      {
        path: '/worker/formOnlineDblink',
        component: () => import('@/pages/online/formOnlineDblink/index.vue'),
        name: 'formOnlineDblink',
        props: getProps,
        meta: { title: '数据库链接', keepalive: true },
      },
      {
        path: '/worker/formOnlineDict',
        component: () => import('@/pages/online/formOnlineDict/index.vue'),
        name: 'formOnlineDict',
        props: getProps,
        meta: { title: '在线表单字典管理', keepalive: true },
      },
      {
        path: '/worker/formOnlinePage',
        component: () => import('@/pages/online/formOnlinePage/index.vue'),
        name: 'formOnlinePage',
        props: getProps,
        meta: { title: '在线表单管理', keepalive: true },
      },
      {
        path: '/worker/onlineForm',
        component: () => import('@/pages/online/OnlinePageRender/index.vue'),
        name: 'onlineForm',
        props: getProps,
        meta: { title: '在线表单', keepalive: true },
      },
      // 工作流模块
      {
        path: '/worker/formMessage',
        component: () => import('@/pages/workflow/formMessage/index.vue'),
        name: 'formMessage',
        props: getProps,
        meta: { title: '催办消息', keepalive: true },
      },
      {
        path: '/worker/formFlowCategory',
        component: () => import('@/pages/workflow/flowCategory/formFlowCategory.vue'),
        name: 'formFlowCategory',
        props: getProps,
        meta: { title: '流程分类管理', keepalive: true },
      },
      {
        path: '/worker/formFlowEntry',
        component: () => import('@/pages/workflow/flowEntry/formFlowEntry.vue'),
        name: 'formFlowEntry',
        props: getProps,
        meta: { title: '流程设计', keepalive: true },
      },
      {
        path: '/worker/formFlowDblink',
        component: () => import('@/pages/workflow/formFlowDblink/index.vue'),
        name: 'formFlowDblink',
        props: getProps,
        meta: { title: '流程数据库链接', keepalive: true },
      },
      {
        path: '/worker/formAllInstance',
        component: () => import('@/pages/workflow/taskManager/formAllInstance.vue'),
        name: 'formAllInstance',
        props: getProps,
        meta: { title: '流程实例', keepalive: true },
      },
      {
        path: '/worker/handlerFlowTask',
        component: () => import('@/pages/workflow/handlerFlowTask/index.vue'),
        name: 'handlerFlowTask',
        props: getProps,
        meta: { title: '流程处理' },
        children: [
          // 静态表单路由设置
          {
            path: '/worker/formOfficeOrderFlow',
            component: () =>
              import('@/pages/workflow/pages/officeOrderFlow/formOfficeOrderFlow.vue'),
            name: 'formOfficeOrderFlow',
            props: getProps,
            meta: { title: '办公用品采购申请审批表单', keepalive: true },
          },
          {
            path: '/worker/OfficeUseApplyFlow',
            component: () =>
              import('@/pages/workflow/pages/ofiiceUseApplyFlow/officeUseApplyFlow.vue'),
            name: 'OfficeUseApplyFlow',
            props: getProps,
            meta: { title: '办公用品领用申请审核表单', keepalive: true },
          },
          {
            path: '/worker/AssetPurchaseOrderFlowInfo',
            component: () =>
              import(
                '@/pages/workflow/pages/assetPurchaseOrderFlow/assetPurchaseOrderFlowInfo.vue'
              ),
            name: 'AssetPurchaseOrderFlowInfo',
            props: getProps,
            meta: { title: '资产采购管理详情表单', keepalive: true },
          },
          {
            path: 'officialDocPreview',
            component: () => import('@/pages/officialDoc/officialDocAudit.vue'),
            name: 'officialDocPreview',
            props: getProps,
            meta: { title: '公文预览', keepalive: true },
          },
          {
            path: '/worker/receiveOfficialDocPreview',
            component: () => import('@/pages/officialDoc/receiveOfficialDocAudit.vue'),
            name: 'receiveOfficialDocPreview',
            props: getProps,
            meta: { title: '公文预览', keepalive: true },
          },
          {
            path: '/worker/meetingAudit',
            component: () => import('@/pages/workflow/pages/meetingAuditFlow/meetingAudit.vue'),
            name: 'meetingAudit',
            props: getProps,
            meta: { title: '会议审批', keepalive: true },
          },
          {
            path: '/worker/bookApplyFlowEdit',
            component: () => import('@/pages/workflow/pages/bookApplyFlow/bookApplyFlowEdit.vue'),
            name: 'bookApplyFlowEdit',
            props: getProps,
            meta: { title: '借阅申请流程页面', keepalive: true },
          },
          {
            path: '/worker/selectBookToFLow',
            component: () => import('@/pages/workflow/pages/selectBookToFLow.vue'),
            name: 'selectBookToFLow',
            props: getProps,
            meta: { title: '选择图书-流程', keepalive: true },
          },
          {
            path: '/worker/CarApplyAudit',
            component: () => import('@/pages/workflow/pages/applyAudit/carApplyAudit.vue'),
            name: 'CarApplyAudit',
            props: getProps,
            meta: { title: '调度审批', keepalive: true },
          },
          {
            path: '/worker/AssetPurchaseOrderFlowEdit',
            component: () =>
              import(
                '@/pages/workflow/pages/assetPurchaseOrderFlow/assetPurchaseOrderFlowEdit.vue'
              ),
            name: 'AssetPurchaseOrderFlowEdit',
            props: getProps,
            meta: { title: '资产采购申请新增', keepalive: true },
          },
          {
            path: '/worker/AssetPurchaseOrderDetailsEdit',
            component: () =>
              import(
                '@/pages/workflow/pages/assetPurchaseOrderFlow/assetPurchaseOrderDetailsEdit.vue'
              ),
            name: 'AssetPurchaseOrderDetailsEdit',
            props: getProps,
            meta: { title: '资产采购申请明细新增', keepalive: true },
          },
          {
            path: '/worker/formFlowReimbursement',
            component: () =>
              import('@/pages/workflow/pages/flowReimbursement/formFlowReimbursement.vue'),
            name: 'formFlowReimbursement',
            props: getProps,
            meta: { title: '报销申请', keepalive: true },
          },
          {
            path: 'travelApplicationPage',
            component: () => import('@/pages/workflow/pages/travelApplicationFlow/travelApplicationPage.vue'),
            name: 'travelApplicationPage',
            props: getProps,
            meta: {title: '出差申请页面', keepalive: true}
          },
          {path: 'VacationApply',
            component: () => import('@/pages/workflow/pages/vacationApply/vacationApply.vue'),
            name: 'VacationApply',
            props: getProps,
            meta: {title: '请假申请', keepalive: true}
          },
          {
            path: '/worker/formFlowReimbursementDetail',
            component: () =>
              import('@/pages/workflow/pages/flowReimbursement/formFlowReimbursementDetail.vue'),
            name: 'formFlowReimbursementDetail',
            props: getProps,
            meta: { title: '编辑报销详情', keepalive: true },
          },
        ],
      },
      {
        path: '/worker/formMyTask',
        component: () => import('@/pages/workflow/taskManager/formMyTask.vue'),
        name: 'formMyTask',
        props: getProps,
        meta: { title: '待办任务', keepalive: true },
      },
      {
        path: '/worker/formMyApprovedTask',
        component: () => import('@/pages/workflow/taskManager/formMyApprovedTask.vue'),
        name: 'formMyApprovedTask',
        props: getProps,
        meta: { title: '已办任务', keepalive: true },
      },
      {
        path: '/worker/formMyHistoryTask',
        component: () => import('@/pages/workflow/taskManager/formMyHistoryTask.vue'),
        name: 'formMyHistoryTask',
        props: getProps,
        meta: { title: '历史流程', keepalive: true },
      },
      // 移动端管理
      {
        path: '/worker/formSudoku',
        component: () => import('@/pages/mobile/formMobileEntry/formSudoku.vue'),
        name: 'formSudoku',
        props: {
          entryType: 1,
        },
        meta: { title: '九宫格配置', keepalive: true },
      },
      {
        path: '/worker/formBanner',
        component: () => import('@/pages/mobile/formMobileEntry/formBanner.vue'),
        name: 'formBanner',
        props: {
          entryType: 0,
        },
        meta: { title: '轮播图配置配置', keepalive: true },
      },
      // 报表路由
      {
        path: '/worker/reportRender',
        component: () => import('@/pages/report/formReportPage/reportRender/index.vue'),
        name: 'reportRender',
        props: getProps,
        meta: { title: '报表', keepalive: true },
      },
      {
        path: '/worker/formReportDblink',
        component: () => import('@/pages/report/formReportDblink/index.vue'),
        name: 'formReportDblink',
        meta: { title: '报表数据源', keepalive: true },
      },
      {
        path: '/worker/formReportDataset',
        component: () => import('@/pages/report/formReportDataset/index.vue'),
        name: 'formReportDataset',
        meta: { title: '报表数据集', keepalive: true },
      },
      {
        path: '/worker/formReportDict',
        component: () => import('@/pages/report/formReportDict/index.vue'),
        name: 'formReportDict',
        meta: { title: '报表字典', keepalive: true },
      },
      {
        path: '/worker/formReportPage',
        component: () => import('@/pages/report/formReportPage/index.vue'),
        name: 'formReportPage',
        meta: { title: '报表页面', keepalive: true },
      },
      {
        path: '/worker/formPrintManage',
        component: () => import('@/pages/report/formPrint/index.vue'),
        name: 'formPrintManage',
        meta: { title: '打印管理', keepalive: true },
      },
      // {
      //   path: 'formSeal',
      //   component: () => import('@/pages/seal/formSeal.vue'),
      //   name: 'formSeal',
      //   props: getProps,
      //   meta: { title: '公章管理管理', keepalive: true },
      // },
      {
        path: '/worker/formRedTemplate',
        component: () => import('@/pages/redTemplate/formRedTemplate.vue'),
        name: 'formRedTemplate',
        props: getProps,
        meta: { title: '套红模版管理', keepalive: true },
      },
      {
        path: '/worker/OfficeSupplyPageList',
        component: () => import('@/pages/office/officeSupplyPageList.vue'),
        name: 'OfficeSupplyPageList',
        props: getProps,
        meta: { title: '办公用品库存', keepalive: true },
      },
      {
        path: '/worker/formContractInfo',
        component: () => import('@/pages/contract/formContractInfo.vue'),
        name: 'formContractInfo',
        props: getProps,
        meta: { title: '创建合同', keepalive: true },
      },
      {
        path: '/worker/formQueryContractInfo',
        component: () => import('@/pages/contract/formQueryContractInfo.vue'),
        name: 'formQueryContractInfo',
        props: getProps,
        meta: { title: '合同查询', keepalive: true },
      },
      {
        path: '/worker/formSupplierPageList',
        component: () => import('@/pages/supplier/formSupplierPageList.vue'),
        name: 'formSupplierPageList',
        props: getProps,
        meta: { title: '供应商管理', keepalive: true },
      },
      {
        path: '/worker/formOfficeOrder',
        component: () => import('@/pages/office/formOfficeOrder.vue'),
        name: 'formOfficeOrder',
        props: getProps,
        meta: { title: '办公用品采购申请表单', keepalive: true },
      },
      {
        path: '/worker/formOfficeOrderInfo',
        component: () => import('@/pages/office/formOfficeOrderInfo.vue'),
        name: 'formOfficeOrderInfo',
        props: getProps,
        meta: { title: '办公用品采购申请详情', keepalive: true },
      },
      {
        path: '/worker/formOfficeOrderStore',
        component: () => import('@/pages/office/formOfficeOrderStore.vue'),
        name: 'formOfficeOrderStore',
        props: getProps,
        meta: { title: '办公用品采购入库', keepalive: true },
      },
      {
        path: '/worker/OfficeOrderPageList',
        component: () => import('@/pages/office/officeOrderPageList.vue'),
        name: 'OfficeOrderPageList',
        props: getProps,
        meta: { title: '办公用品采购申请', keepalive: true },
      },
      {
        path: '/worker/formContractReceipt',
        component: () => import('@/pages/contract/formContractReceipt.vue'),
        name: 'formContractReceipt',
        props: getProps,
        meta: { title: '票据管理', keepalive: true },
      },
      {
        path: '/worker/officeOrderPageList',
        component: () => import('@/pages/office/officeOrderPageList.vue'),
        name: 'officeOrderPageList',
        props: getProps,
        meta: { title: '办公用品采购管理', keepalive: true },
      },
      {
        path: '/worker/formContractReceipt',
        component: () => import('@/pages/contract/formContractReceipt.vue'),
        name: 'formContractReceipt',
        props: getProps,
        meta: { title: '票据管理', keepalive: true },
      },
      {
        path: '/worker/formMeetingRoom',
        component: () => import('@/pages/meeting/formMeetingRoom.vue'),
        name: 'formMeetingRoom',
        props: getProps,
        meta: { title: '会议室管理', keepalive: true },
      },
      {
        path: '/worker/formMeetingRoomDevice',
        component: () => import('@/pages/meeting/formMeetingRoomDevice.vue'),
        name: 'formMeetingRoomDevice',
        props: getProps,
        meta: { title: '会议设备', keepalive: true },
      },
      {
        path: '/worker/formMeetingFlowDevice',
        component: () => import('@/pages/meeting/formMeetingFlowDevice.vue'),
        name: 'formMeetingFlowDevice',
        props: getProps,
        meta: { title: '流动设备', keepalive: true },
      },
      {
        path: '/worker/formMeetingApply',
        component: () => import('@/pages/meeting/formMeetingApply.vue'),
        name: 'formMeetingApply',
        props: getProps,
        meta: { title: '会议预约', keepalive: true },
      },
      {
        path: '/worker/calendar',
        component: () => import('@/pages/meeting/formSchedule.vue'),
        name: 'calendar',
        props: getProps,
        meta: { title: '日程管理', keepalive: true },
      },
      {
        path: '/worker/formScheduleTotal',
        component: () => import('@/pages/meeting/formScheduleTotal.vue'),
        name: 'formScheduleTotal',
        props: getProps,
        meta: { title: '日程统计', keepalive: true },
      },
      {
        path: '/worker/formMeetingOrder',
        component: () => import('@/pages/meeting/formMeetingOrder.vue'),
        name: 'formMeetingOrder',
        props: getProps,
        meta: { title: '我的预约', keepalive: true },
      },
      {
        path: '/worker/formMeetingAudit',
        component: () => import('@/pages/meeting/formMeetingAudit.vue'),
        name: 'formMeetingAudit',
        props: getProps,
        meta: { title: '会议审批', keepalive: true },
      },
      {
        path: '/worker/formMeetingSummary',
        component: () => import('@/pages/meeting/formMeetingSummary.vue'),
        name: 'formMeetingSummary',
        props: getProps,
        meta: { title: '会议纪要', keepalive: true },
      },
      {
        path: '/worker/formOfficialDoc',
        component: () => import('@/pages/officialDoc/formOfficialDoc.vue'),
        name: 'formOfficialDoc',
        props: getProps,
        meta: { title: '发文起草', keepalive: true },
      },
      {
        path: '/worker/sendOfficialDoc',
        component: () => import('@/pages/officialDoc/sendOfficialDoc.vue'),
        name: 'sendOfficialDoc',
        props: getProps,
        meta: { title: '公文发文', keepalive: true },
      },
      // {
      //   path: 'officialSearchDoc',
      //   component: () => import('@/pages/officialDoc/searchOfficialDoc.vue'),
      //   name: 'officialSearchDoc',
      //   props: getProps,
      //   meta: { title: '公文查询', keepalive: true },
      // },
      {
        path: '/worker/formReceiveOfficialDoc',
        component: () => import('@/pages/officialDoc/formReceiveOfficialDoc.vue'),
        name: 'formReceiveOfficialDoc',
        props: getProps,
        meta: { title: '收文管理', keepalive: true },
      },
      {
        path: '/worker/BookList',
        component: () => import('@/pages/book/bookList.vue'),
        name: 'BookList',
        props: getProps,
        meta: { title: '图书管理-图书列表', keepalive: true },
      },
      {
        path: '/worker/questionnairePage',
        component: () => import('@/pages/questionnaire/questionnairePage/index.vue'),
        name: 'questionnairePage',
        props: getProps,
        meta: { title: '问卷列表', keepalive: true },
      },
      {
        path: '/worker/voteProjectMng',
        component: () => import('@/pages/vote/voteProjectMng.vue'),
        name: 'voteProjectMng',
        props: getProps,
        meta: { title: '投票管理', keepalive: true },
      },
      {
        path: '/worker/formVoteProject',
        component: () => import('@/pages/vote/formVoteProject.vue'),
        name: 'formVoteProject',
        props: getProps,
        meta: { title: '发起投票', keepalive: true },
      },
      {
        path: '/worker/myVoteProject',
        component: () => import('@/pages/vote/myVoteProject.vue'),
        name: 'myVoteProject',
        props: getProps,
        meta: { title: '参与投票', keepalive: true },
      },
      {
        path: '/worker/formSalary',
        component: () => import('@/pages/salary/formSalary.vue'),
        name: 'formSalary',
        props: getProps,
        meta: { title: '薪资管理管理', keepalive: true },
      },
      {
        path: '/worker/formWelfare',
        component: () => import('@/pages/salary/formWelfare.vue'),
        name: 'formWelfare',
        props: getProps,
        meta: { title: '福利管理管理', keepalive: true },
      },
      {
        path: '/worker/safetyCheckNoticeList',
        component: () => import('@/pages/safetyCheck/safetyCheckNoticeList.vue'),
        name: 'safetyCheckNoticeList',
        props: getProps,
        meta: { title: '检查通知列表', keepalive: true },
      },
      {
        path: '/worker/safetyCheckNoticeEdit',
        component: () => import('@/pages/safetyCheck/safetyCheckNoticeEdit.vue'),
        name: 'safetyCheckNoticeEdit',
        props: getProps,
        meta: { title: '编辑安全检查通知', keepalive: true },
      },
      {
        path: '/worker/safetyCheckFeedbackList',
        component: () => import('@/pages/safetyCheck/safetyCheckFeedbackList.vue'),
        name: 'safetyCheckFeedbackList',
        props: getProps,
        meta: { title: '检查反馈列表', keepalive: true },
      },
      {
        path: '/worker/safetyCheckFeedback',
        component: () => import('@/pages/safetyCheck/safetyCheckFeedback.vue'),
        name: 'safetyCheckFeedback',
        props: getProps,
        meta: { title: '编辑检查反馈', keepalive: true },
      },
      {
        path: '/worker/attendanceClock',
        component: () => import('@/pages/attendance/attendanceClock.vue'),
        name: 'attendanceClock',
        props: getProps,
        meta: { title: '考勤打卡', keepalive: false },
      },
      {
        path: '/worker/attendanceRecordView',
        component: () => import('@/pages/attendance/attendanceRecordView.vue'),
        name: 'attendanceRecordView',
        props: getProps,
        meta: { title: '考勤记录', keepalive: true },
      },
      {
        path: '/worker/attendanceConfig',
        component: () => import('@/pages/attendance/attendanceConfig.vue'),
        name: 'attendanceConfig',
        props: getProps,
        meta: { title: '考勤配置', keepalive: true },
      },
      {
        path: '/worker/formExamine',
        component: () => import('@/pages/examine/formExamine.vue'),
        name: 'formExamine',
        props: getProps,
        meta: { title: '考核计划管理', keepalive: true },
      },
      {
        path: '/worker/formExamineUser',
        component: () => import('@/pages/examine/formExamineUser.vue'),
        name: 'formExamineUser',
        props: getProps,
        meta: { title: '人员考核管理', keepalive: true },
      },
      {
        path: '/worker/formTarget',
        component: () => import('@/pages/examine/formTarget.vue'),
        name: 'formTarget',
        props: getProps,
        meta: { title: '考核项目管理', keepalive: true },
      },
      {
        path: '/worker/studyCategoriesList',
        component: () => import('@/pages/study/studyCategoriesList.vue'),
        name: 'studyCategoriesList',
        props: getProps,
        meta: { title: '学习分类列表', keepalive: true },
      },
      {
        path: '/worker/studyResourcesList',
        component: () => import('@/pages/study/studyResourcesList.vue'),
        name: 'studyResourcesList',
        props: getProps,
        meta: { title: '课件列表', keepalive: true },
      },
      {
        path: '/worker/bookApplyList',
        component: () => import('@/pages/workflow/pages/bookApplyFlow/bookApplyList.vue'),
        name: 'bookApplyList',
        props: getProps,
        meta: { title: '借阅申请列表', keepalive: true },
      },
      {
        path: '/worker/OfficeUseManagePageList',
        component: () => import('@/pages/office/apply/officeUseManagePageList.vue'),
        name: 'OfficeUseManagePageList',
        props: getProps,
        meta: { title: '办公用品领用管理', keepalive: true },
      },
      {
        path: '/worker/OfficeUseApplyPageList',
        component: () => import('@/pages/office/apply/officeUseApplyPageList.vue'),
        name: 'OfficeUseApplyPageList',
        props: getProps,
        meta: { title: '办公用品领用申请', keepalive: true },
      },
      {
        path: '/worker/OfficeUseApplyEdit',
        component: () => import('@/pages/office/apply/officeUseApplyEdit.vue'),
        name: 'OfficeUseApplyEdit',
        props: getProps,
        meta: { title: '办公用品申请', keepalive: true },
      },
      {
        path: '/worker/OfficeUseApplyGrant',
        component: () => import('@/pages/office/apply/officeUseApplyGrant.vue'),
        name: 'OfficeUseApplyGrant',
        props: getProps,
        meta: { title: '办公用品发放', keepalive: true },
      },
      {
        path: '/worker/waitBackBookList',
        component: () => import('@/pages/book/waitBackBookList.vue'),
        name: 'waitBackBookList',
        props: getProps,
        meta: { title: '待归还图书列表', keepalive: true },
      },
      {
        path: '/worker/lookBookList',
        component: () => import('@/pages/book/lookBookList.vue'),
        name: 'lookBookList',
        props: getProps,
        meta: { title: '图书查看列表', keepalive: true },
      },
      {
        path: '/worker/formVehicle',
        component: () => import('@/pages/car/formVehicle.vue'),
        name: 'formVehicle',
        props: getProps,
        meta: { title: '车辆信息管理', keepalive: true },
      },
      {
        path: '/worker/formVehicleReturn',
        component: () => import('@/pages/car/formVehicleReturn.vue'),
        name: 'formVehicleReturn',
        props: getProps,
        meta: { title: '还车管理', keepalive: true },
      },
      {
        path: '/worker/formDriver',
        component: () => import('@/pages/car/formDriver.vue'),
        name: 'formDriver',
        props: getProps,
        meta: { title: '司机管理', keepalive: true },
      },
      {
        path: '/worker/formVehicleApply',
        component: () => import('@/pages/car/formVehicleApply.vue'),
        name: 'formVehicleApply',
        props: getProps,
        meta: { title: '用车申请管理', keepalive: true },
      },
      {
        path: '/worker/formVehicleApplyAudit',
        component: () => import('@/pages/car/formVehicleApplyAudit.vue'),
        name: 'formVehicleApplyAudit',
        props: getProps,
        meta: { title: '调度审批管理', keepalive: true },
      },
      {
        path: '/worker/studyCourseMng',
        component: () => import('@/pages/study/studyCourseMng.vue'),
        name: 'studyCourseMng',
        props: getProps,
        meta: { title: '学习培训管理', keepalive: true },
      },
      {
        path: '/worker/studyCourseEdit',
        component: () => import('@/pages/study/studyCourseEdit.vue'),
        name: 'studyCourseEdit',
        props: getProps,
        meta: { title: '编辑学习培训', keepalive: true },
      },
      {
        path: '/worker/myStudyCourseList',
        component: () => import('@/pages/study/myStudyCourseList.vue'),
        name: 'myStudyCourseList',
        props: getProps,
        meta: { title: '我的学习培训列表', keepalive: true },
      },
      {
        path: '/worker/formTbExpense',
        component: () => import('@/pages/tbExpense/formTbExpense.vue'),
        name: 'formTbExpense',
        props: getProps,
        meta: { title: '我的报销', keepalive: true },
      },
      {
        path: 'VacationPage',
        component: () => import('@/pages/workflow/pages/vacationApply/vacationPage.vue'),
        name: 'VacationPage',
        props: getProps,
        meta: {title: '请假管理', keepalive: true}
      },
      {
        path: '/worker/assetCategoryPageList',
        component: () => import('@/pages/asset/category/assetCategoryPageList.vue'),
        name: 'assetCategoryPageList',
        props: getProps,
        meta: { title: '资产类型管理', keepalive: true },
      },
      {
        path: '/worker/AssetPurchaseOrderFlowPage',
        component: () =>
          import('@/pages/workflow/pages/assetPurchaseOrderFlow/assetPurchaseOrderFlowPage.vue'),
        name: 'AssetPurchaseOrderFlowPage',
        props: getProps,
        meta: { title: '资产采购申请', keepalive: true },
      },
      {
        path: '/worker/AssetPurchaseOrderPage',
        component: () => import('@/pages/asset/order/assetPurchaseOrderPage.vue'),
        name: 'AssetPurchaseOrderPage',
        props: getProps,
        meta: { title: '资产采购管理', keepalive: true },
      },
      {
        path: '/worker/AssetPurchaseOrderStoreEdit',
        component: () => import('@/pages/asset/order/assetPurchaseOrderStoreEdit.vue'),
        name: 'AssetPurchaseOrderStoreEdit',
        props: getProps,
        meta: { title: '资产采购管理入库', keepalive: true },
      },
      {
        path: '/worker/AssetPage',
        component: () => import('@/pages/asset/assetPage.vue'),
        name: 'AssetPage',
        props: getProps,
        meta: { title: '固定资产管理', keepalive: true },
      },
      {
        path: '/worker/MyAssetPage',
        component: () => import('@/pages/asset/myAssetPage.vue'),
        name: 'MyAssetPage',
        props: getProps,
        meta: { title: '我的资产', keepalive: true },
      },
      {
        path: '/worker/formFlowReimbursementOrder',
        component: () => import('@/pages/workflow/pages/flowReimbursement/formFlowReimbursementOrder.vue'),
        name: 'formFlowReimbursementOrder',
        props: getProps,
        meta: {title: '报销工单', keepalive: true}
      },
      {
        path: 'travelApplicationList',
        component: () => import('@/pages/workflow/pages/travelApplicationFlow/travelApplicationList.vue'),
        name: 'travelApplicationList',
        props: getProps,
        meta: {title: '出差申请工单列表', keepalive: true}
      },
    ],
  },
  // TODO 第三方接入路由
  {
    path: '/thirdParty',
    component: () => import('@/components/thirdParty/index.vue'),
    name: 'thirdParty',
    props: getProps,
    children: [
      // 流程分类列表
      {
        path: 'thirdFormFlowCategory',
        name: 'thirdFormFlowCategory',
        props: getProps,
        component: () => import('@/pages/workflow/flowCategory/formFlowCategory.vue'),
      },
      // 流程分类 新增、编辑
      {
        path: 'thirdAddFormFlowCategory',
        name: 'thirdAddFormFlowCategory',
        props: getProps,
        component: () => import('@/pages/workflow/flowCategory/formEditFlowCategory.vue'),
      },
      // 流程实例列表
      {
        path: 'thirdFormAllInstance',
        name: 'thirdFormAllInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formAllInstance.vue'),
      },
      // 流程图
      {
        path: 'thirdFormTaskProcessViewer',
        name: 'thirdFormTaskProcessViewer',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formTaskProcessViewer.vue'),
      },
      // 流程干涉
      {
        path: 'thirdFormInterposeInstance',
        name: 'thirdFormInterposeInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formInterposeInstance.vue'),
      },
      // 流程复活
      {
        path: 'thirdFormRestartInstance',
        name: 'thirdFormRestartInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formRestart.vue'),
      },
      // 数据补偿
      {
        path: 'thirdFormCompensationInstance',
        name: 'thirdFormCompensationInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/processCompensation.vue'),
      },
      // 流程终止
      {
        path: 'thirdFormStopTaskInstance',
        name: 'thirdFormStopTaskInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/stopTask.vue'),
      },
      // 选择用户-处理用户
      {
        path: 'thirdTaskUserSelect',
        name: 'thirdTaskUserSelect',
        props: getProps,
        component: () => import('@/pages/workflow/components/TaskUserSelect.vue'),
      },
      // 选择用户-跳转节点
      {
        path: 'thirdSelectUserTask',
        name: 'thirdSelectUserTask',
        props: getProps,
        component: () => import('@/pages/workflow/components/UserTaskSelect/userTaskSelectDlg.vue'),
      },
      // 流程设计
      {
        path: 'thirdFlowDblink',
        name: 'thirdFlowDblink',
        props: getProps,
        component: () => import('@/pages/workflow/formFlowDblink/index.vue'),
      },
      {
        path: 'thirdEditFlowDblink',
        name: 'thirdEditFlowDblink',
        props: getProps,
        component: () => import('@/pages/workflow/formFlowDblink/editFlowDblink.vue'),
      },
      {
        path: 'thirdFormFlowEntry',
        name: 'thirdFormFlowEntry',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formFlowEntry.vue'),
      },
      {
        path: 'thirdFormEditFlowEntry',
        name: 'thirdFormEditFlowEntry',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formEditFlowEntry.vue'),
      },
      {
        path: 'thirdFormPublishedFlowEntry',
        name: 'thirdFormPublishedFlowEntry',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formPublishedFlowEntry.vue'),
      },
      {
        path: 'thirdHandlerFlowTask',
        name: 'thirdHandlerFlowTask',
        props: getProps,
        component: () => import('@/pages/workflow/handlerFlowTask/index.vue'),
      },
      // 流程设计-候选用户组
      {
        path: 'thirdTaskGroupSelect',
        name: 'thirdTaskGroupSelect',
        props: getProps,
        component: () => import('@/pages/workflow/components/TaskGroupSelect.vue'),
      },
      // 流程设计-选择岗位
      {
        path: 'thirdTaskPostSelect',
        name: 'thirdTaskPostSelect',
        props: getProps,
        component: () => import('@/pages/workflow/components/TaskPostSelect.vue'),
      },
      // 流程设计-抄送
      {
        path: 'thirdAddCopyForItem',
        name: 'thirdAddCopyForItem',
        props: getProps,
        component: () => import('@/pages/workflow/components/CopyForSelect/addCopyForItem.vue'),
      },
      // 流程设计-任务按钮
      {
        path: 'thirdEditOperation',
        name: 'thirdEditOperation',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/formEditOperation.vue'),
      },
      // 流程设计-任务表单权限
      {
        path: 'thirdSetOnlineFormAuth',
        name: 'thirdSetOnlineFormAuth',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/formSetOnlineFormAuth.vue'),
      },
      // 流程设计-添加变量
      {
        path: 'thirdFormEditFlowEntryVariable',
        name: 'thirdFormEditFlowEntryVariable',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formEditFlowEntryVariable.vue'),
      },
      // 流程设计- 新建状态
      {
        path: 'thirdFormEditFlowEntryStatus',
        name: 'thirdFormEditFlowEntryStatus',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formEditFlowEntryStatus.vue'),
      },
      // 流程设计- 任务提交
      {
        path: 'thirdTaskCommit',
        name: 'thirdTaskCommit',
        props: getProps,
        component: () => import('@/pages/workflow/components/TaskCommit.vue'),
      },
      // 自动化任务 - 编辑过滤条件
      {
        path: 'thirdEditTableFilter',
        name: 'thirdEditTableFilter',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editSrcTableFilter.vue'),
      },
      // 自动化任务 - 编辑更新字段
      {
        path: 'thirdEditFieldUpdateData',
        name: 'thirdEditFieldUpdateData',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editInsertData.vue'),
      },
      // 自动化任务 - 编辑响应字段
      {
        path: 'thirdEditResponseData',
        name: 'thirdEditResponseData',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editResponseData.vue'),
      },
      // 自动化任务 - 编辑HTTP请求参数
      {
        path: 'thirdEditHttpRequestParam',
        name: 'thirdEditHttpRequestParam',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editHttpParameter.vue'),
      },
      // 自动化任务 - 编辑HTTP请求头
      {
        path: 'thirdEditHttpHeader',
        name: 'thirdEditHttpHeader',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editHttpHeader.vue'),
      },
      // 自动化任务 - 编辑聚合计算字段
      {
        path: 'thirdEditAggregationData',
        name: 'thirdEditAggregationData',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editAggregationData.vue'),
      },
      // 自动化任务 - 编辑计算字段
      {
        path: 'thirdEditFormulaData',
        name: 'thirdEditFormulaData',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editFormulaData.vue'),
      },
      // 待办任务
      {
        path: 'thirdFormMyTask',
        name: 'thirdFormMyTask',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formMyTask.vue'),
      },
      // 历史任务
      {
        path: 'thirdFormMyHistoryTask',
        name: 'thirdFormMyHistoryTask',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formMyHistoryTask.vue'),
      },
      // 已办任务
      {
        path: 'thirdFormMyApprovedTask',
        name: 'thirdFormMyApprovedTask',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formMyApprovedTask.vue'),
      },
      // 在线表单部分
      {
        path: 'thirdOnlineForm',
        name: 'thirdOnlineForm',
        props: getProps,
        component: () => import('@/pages/online/OnlinePageRender/index.vue'),
      },
      {
        path: 'thirdOnlineEditForm',
        name: 'thirdOnlineEditForm',
        props: getProps,
        component: () => import('@/pages/online/OnlinePageRender/OnlineEditForm/index.vue'),
      },
      {
        path: 'thirdFormOnlineDict',
        name: 'thirdFormOnlineDict',
        props: getProps,
        component: () => import('@/pages/online/formOnlineDict/index.vue'),
      },
      {
        path: 'thirdEditOnlineDict',
        name: 'thirdEditOnlineDict',
        props: getProps,
        component: () => import('@/pages/online/formOnlineDict/EditOnlineDict.vue'),
      },
      {
        path: 'thirdOnlinePage',
        name: 'thirdOnlinePage',
        props: getProps,
        component: () => import('@/pages/online/formOnlinePage/index.vue'),
      },
      {
        path: 'thirdEditOnlinePage',
        name: 'thirdEditOnlinePage',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/index.vue'),
      },
      {
        path: 'thirdEditOnlineForm',
        name: 'thirdEditOnlineForm',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/editOnlineForm.vue'),
      },
      {
        path: 'thirdEditPageDatasource',
        name: 'thirdEditPageDatasource',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/editOnlinePageDatasource.vue'),
      },
      {
        path: 'thirdEditPageRelation',
        name: 'thirdEditPageRelation',
        props: getProps,
        component: () =>
          import('@/pages/online/editOnlinePage/editOnlinePageDatasourceRelation.vue'),
      },
      {
        path: 'thirdSetOnlineTableColumnRule',
        name: 'thirdSetOnlineTableColumnRule',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/setOnlineTableColumnRule.vue'),
      },
      {
        path: 'thirdEditVirtualColumnFilter',
        name: 'thirdEditVirtualColumnFilter',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/editVirtualColumnFilter.vue'),
      },
      {
        path: 'thirdEditTableColumn',
        name: 'thirdEditTableColumn',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/formDesign/editTableColumn.vue'),
      },
      {
        path: 'thirdEditCustomFormOperate',
        name: 'thirdEditCustomFormOperate',
        props: getProps,
        component: () =>
          import('@/pages/online/editOnlinePage/formDesign/components/EditCustomFormOperate.vue'),
      },
      {
        path: 'thirdEditFormField',
        name: 'thirdEditFormField',
        props: getProps,
        component: () =>
          import('@/pages/online/editOnlinePage/formDesign/components/EditFormField.vue'),
      },
      {
        path: 'thirdEditDictParamValue',
        name: 'thirdEditDictParamValue',
        props: getProps,
        component: () =>
          import(
            '@/pages/online/editOnlinePage/formDesign/components/CustomWidgetDictSetting/EditDictParamValue.vue'
          ),
      },
      {
        path: 'thirdEditOnlineTableColumn',
        name: 'thirdEditOnlineTableColumn',
        props: getProps,
        component: () =>
          import(
            '@/pages/online/editOnlinePage/formDesign/components/OnlineTableColumnSetting/editOnlineTableColumn.vue'
          ),
      },
      {
        path: 'thirdEditOnlineTabPanel',
        name: 'thirdEditOnlineTabPanel',
        props: getProps,
        component: () =>
          import(
            '@/pages/online/editOnlinePage/formDesign/components/OnlineTabPanelSetting/editOnlineTabPanel.vue'
          ),
      },
      {
        path: 'thirdOnlineDblink',
        name: 'thirdOnlineDblink',
        props: getProps,
        component: () => import('@/pages/online/formOnlineDblink/index.vue'),
      },
      {
        path: 'thirdEditOnlineDblink',
        name: 'thirdEditOnlineDblink',
        props: getProps,
        component: () => import('@/pages/online/formOnlineDblink/editOnlineDblink.vue'),
      },
      // 打印部分
      {
        path: 'thirdPrint',
        name: 'thirdPrint',
        props: getProps,
        component: () => import('@/pages/report/formPrint/index.vue'),
      },
      {
        path: 'thirdEditPrintGroup',
        name: 'thirdEditPrintGroup',
        props: getProps,
        component: () => import('@/pages/report/formPrint/editPrintManageGroup.vue'),
      },
      {
        path: 'thirdPrintPreview',
        name: 'thirdPrintPreview',
        props: getProps,
        component: () => import('@/pages/report/formPrint/components/previewPrint.vue'),
      },
      {
        path: 'thirdPrintSpreadSheet',
        name: 'thirdPrintSpreadSheet',
        props: getProps,
        component: () => import('@/pages/report/formPrint/components/previewPrintSpreadSheet.vue'),
      },
      {
        path: 'thirdEditPrint',
        name: 'thirdEditPrint',
        props: getProps,
        component: () => import('@/pages/report/formPrint/editPrintTemplate.vue'),
      },
      // 设置数据集参数
      {
        path: 'thirdSetReportDatasetParam',
        name: 'thirdSetReportDatasetParam',
        props: getProps,
        component: () => import('@/pages/report/components/SetReportDatasetParam.vue'),
      },
      // 设置字段过滤
      {
        path: 'thirdEditReportColumnFilter',
        name: 'thirdEditReportColumnFilter',
        props: getProps,
        component: () =>
          import('@/pages/report/components/ReportColumnFilter/editReportColumnFilter.vue'),
      },
      // 设置字段排序
      {
        path: 'thirdEditReportColumnOrder',
        name: 'thirdEditReportColumnOrder',
        props: getProps,
        component: () =>
          import('@/pages/report/components/ReportColumnOrder/editReportColumnOrder.vue'),
      },
      // 数据集
      {
        path: 'thirdReportDataset',
        name: 'thirdReportDataset',
        props: getProps,
        component: () => import('@/pages/report/formReportDataset/index.vue'),
      },
      {
        path: 'thirdEditReportDataset',
        name: 'thirdEditReportDataset',
        props: getProps,
        component: () => import('@/pages/report/formReportDataset/editReportDataset.vue'),
      },
      {
        path: 'thirdEditReportDatasetGroup',
        name: 'thirdEditReportDatasetGroup',
        props: getProps,
        component: () => import('@/pages/report/formReportDataset/editReportDatasetGroup.vue'),
      },
      {
        path: 'thirdEditDatasetParam',
        name: 'thirdEditDatasetParam',
        props: getProps,
        component: () => import('@/pages/report/formReportDataset/components/editDatasetParam.vue'),
      },
      {
        path: 'thirdEditDatasetRelation',
        name: 'thirdEditDatasetRelation',
        props: getProps,
        component: () =>
          import('@/pages/report/formReportDataset/components/editReportRelation.vue'),
      },
      {
        path: 'thirdPrintEditTemplateWord',
        name: 'thirdPrintEditTemplateWord',
        props: getProps,
        component: () => import('@/pages/report/formPrint/components/editTemplateWordDataset.vue'),
      },
      {
        path: 'thirdPrintEditTemplateWordColumn',
        name: 'thirdPrintEditTemplateWordColumn',
        props: getProps,
        component: () => import('@/pages/report/formPrint/components/editTemplateWordColumn.vue'),
      },
      // 数据库链接
      {
        path: 'thirdReportDblink',
        name: 'thirdReportDblink',
        props: getProps,
        component: () => import('@/pages/report/formReportDblink/index.vue'),
      },
      {
        path: 'thirdEditReportDblink',
        name: 'thirdEditReportDblink',
        props: getProps,
        component: () => import('@/pages/report/formReportDblink/editReportDblink.vue'),
      },
      // 报表字典
      {
        path: 'thirdReportDict',
        name: 'thirdReportDict',
        props: getProps,
        component: () => import('@/pages/report/formReportDict/index.vue'),
      },
      {
        path: 'thirdEditReportDict',
        name: 'thirdEditReportDict',
        props: getProps,
        component: () => import('@/pages/report/formReportDict/editReportDict.vue'),
      },
      // 报表
      {
        path: 'thirdReportPage',
        name: 'thirdReportPage',
        props: getProps,
        component: () => import('@/pages/report/formReportPage/index.vue'),
      },
      {
        path: 'thirdEditReportPageGroup',
        name: 'thirdEditReportPageGroup',
        props: getProps,
        component: () => import('@/pages/report/formReportPage/editReportPageGroup.vue'),
      },
      {
        path: 'thirdEditReportPage',
        name: 'thirdEditReportPage',
        props: getProps,
        component: () => import('@/pages/report/formReportPage/editReportPage/index.vue'),
      },
      {
        path: 'thirdEditReportFormParam',
        name: 'thirdEditReportFormParam',
        props: getProps,
        component: () =>
          import(
            '@/pages/report/formReportPage/reportDesign/components/CustomFormSetting/editFormParam.vue'
          ),
      },
      {
        path: 'thirdEditReportFormOperate',
        name: 'thirdEditReportFormOperate',
        props: getProps,
        component: () =>
          import(
            '@/pages/report/formReportPage/reportDesign/components/CustomReportOperationSetting/editReportOperation.vue'
          ),
      },
      {
        path: 'thirdEditReportRouterOperate',
        name: 'thirdEditReportRouterOperate',
        props: getProps,
        component: () =>
          import(
            '@/pages/report/formReportPage/reportDesign/components/CustomReportOperationSetting/editRouteOperation.vue'
          ),
      },
      {
        path: 'thirdReport',
        name: 'thirdReport',
        props: getProps,
        component: () => import('@/pages/report/formReportPage/reportRender/index.vue'),
      },
      {
        path: 'thirdReportForm',
        name: 'thirdReportForm',
        props: getProps,
        component: () => import('@/pages/report/formReportPage/reportRender/ReportForm/index.vue'),
      },
      // 通用
      {
        path: 'thirdEditDictParamValue2',
        name: 'thirdEditDictParamValue2',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/CustomWidgetDictSetting/editDictParamValue.vue'
          ),
      },
      {
        path: 'thirdEditOnlineTableColumn2',
        name: 'thirdEditOnlineTableColumn2',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/OnlineTableColumnSetting/editOnlineTableColumn.vue'
          ),
      },
      {
        path: 'thirdEditOnlineTabPanel2',
        name: 'thirdEditOnlineTabPanel2',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/OnlineTabPanelSetting/editOnlineTabPanel.vue'
          ),
      },
      {
        path: 'thirdSelectDept',
        name: 'thirdSelectDept',
        props: getProps,
        component: () => import('@/components/DeptSelect/DeptSelectDlg.vue'),
      },
      {
        path: 'thirdSelectUser',
        name: 'thirdSelectUser',
        props: getProps,
        component: () => import('@/components/UserSelect/UserSelectDlg.vue'),
      },
      {
        path: 'thirdSelectData',
        name: 'thirdSelectData',
        props: getProps,
        component: () => import('@/online/components/OnlineCustomDataSelect/DataSelectDlg.vue'),
      },
      {
        path: 'thirdEditDataViewColumn',
        name: 'thirdEditDataViewColumn',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/ChartDatasetSetting/editDataViewTableColumn.vue'
          ),
      },
      {
        path: 'thirdEditWidgetColumnBind',
        name: 'thirdEditWidgetColumnBind',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/ChartDatasetSetting/editColumnBind.vue'
          ),
      },
      {
        path: 'thirdSetDatasetPaam',
        name: 'thirdSetDatasetPaam',
        props: getProps,
        component: () => import('@/online/components/SetReportDatasetParam/index.vue'),
      },
      {
        path: 'thirdEditWidgetCategroyColumn',
        name: 'thirdEditWidgetCategroyColumn',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/ChartDatasetSetting/editWidgetCategoryColumn.vue'
          ),
      },
      {
        path: 'thirdEditWidgetIndexColumn',
        name: 'thirdEditWidgetIndexColumn',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/ChartDatasetSetting/editWidgetIndexColumn.vue'
          ),
      },
      {
        path: 'thirdEditWidgetOrderInfo',
        name: 'thirdEditWidgetOrderInfo',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/ChartDatasetSetting/editWidgetOrderInfo.vue'
          ),
      },
      {
        path: 'thirdEditReportColumnFilter',
        name: 'thirdEditReportColumnFilter',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/ChartDatasetSetting/editReportColumnFilter.vue'
          ),
      },
      {
        path: 'thirdEditCustomEvent',
        name: 'thirdEditCustomEvent',
        props: getProps,
        component: () => import('@/online/components/CustomEventSetting/editCustomEvent.vue'),
      },
    ],
  },
];
